export default {
  lista: [],
  order: '',
  direcao: '',
  estaCarregando: false,
  paginaAtual: 1,
  totalItens: null,
  todosItensCarregados: false,
  itemSelecionadoID: null,
  itemSelecionado: {
    id: null,
    descricao: null,
    tipo_template: null,
    modelo_html: null
  },
  filtro: {
    descricao: null,
    situacao: null
  }
}
